import {
  ModalFooter as CModalFooter,
  ModalFooterProps as CModalFooterProps,
  Divider,
} from '@chakra-ui/react';

interface ModalFooterProps extends CModalFooterProps {
  withDivider?: boolean;
}

export const ModalFooter = ({
  withDivider = true,
  ...props
}: ModalFooterProps) => (
  <>
    {withDivider && <Divider />}
    <CModalFooter gap={5} {...props} />
  </>
);
